import { render, staticRenderFns } from "./OrderDispute.vue?vue&type=template&id=bb806736&scoped=true&"
import script from "./OrderDispute.vue?vue&type=script&lang=js&"
export * from "./OrderDispute.vue?vue&type=script&lang=js&"
import style0 from "./OrderDispute.vue?vue&type=style&index=0&id=bb806736&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb806736",
  null
  
)

export default component.exports